

















































































import SimpleMap from '../../core/components/SimpleMap.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    parseFloatNumber,
    openTravelWithParameter
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import {
    booleanFormatter,
    formattedDate,
    getOnlyDateFromTimestamp,
    nullFormatter
} from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalCompanyHarvest from './ModalCompanyHarvest.vue';
import ModalViewSegments from './ModalViewSegments.vue';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { dateFormat } from 'highcharts';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        DatePickerRange,
        Button,
        SimpleTable,
        ModalViewSegments
    }
})
export default class WorkSegments extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    items: Array<object> = [];
    @Prop({ default: null }) vehicleID: number | null;
    @Prop({
        default() {
            return [];
        }
    })
    farmingsList: number | null;
    @Prop({
        default() {
            return [];
        }
    })
    companiesList: number | null;
    @Prop({ default: -1 }) companyId: number;
    @Prop({ default: false }) isSowing: boolean;
    dateRangeSelected: any = [];
    filtersCompanySelected: any = null;
    filtersCompanyRV: boolean = false;
    filtersHarvestSelected: any = null;
    filtersHarvestRV: boolean = false;
    loadingSegments: boolean = false;
    cancelTokenLoadSegment: any = null;
    pendingSegment: boolean = false;

    //work segmentts
    segmentInfo: object | null = null;
    visibleModalViewSegments: boolean = false;

    parseNumber(value) {
        return parseFloatNumber(value);
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    mounted() {
        this.setTodayDate();
    }

    get getHeaders() {
        if (!this.isSowing) {
            return [
                {
                    text: 'Fecha Inicio',
                    value: 'start',
                    formatter: this.dateFormatter,
                    sortable: true,
                    width: '200px'
                },
                {
                    text: 'Fecha Fin',
                    value: 'end',
                    formatter: this.dateFormatter,
                    sortable: true,
                    width: '200px'
                },
                {
                    text: 'Area cosechada',
                    value: 'harvested_area',
                    formatter: this.parseNumber,
                    sortable: true
                },
                {
                    text: 'Area cosechada cruda',
                    value: 'raw_area',
                    formatter: this.parseNumber,
                    sortable: true
                },
                {
                    text: 'Area solapada',
                    value: 'overlapped_area',
                    formatter: this.parseNumber,
                    sortable: true
                },
                {
                    text: 'Chacra',
                    value: 'ranch.name',
                    sortable: true
                },
                {
                    text: 'Cosecha',
                    value: 'harvest.name',
                    sortable: true
                },
                {
                    text: 'Variable',
                    value: 'variable',
                    sortable: true
                }
            ];
        } else {
            return [
                {
                    text: 'Fecha Inicio',
                    value: 'start',
                    formatter: this.dateFormatter,
                    sortable: true,
                    width: '200px'
                },
                {
                    text: 'Fecha Fin',
                    value: 'end',
                    formatter: this.dateFormatter,
                    sortable: true,
                    width: '200px'
                },
                {
                    text: 'Area sembrada',
                    value: 'sown_area',
                    formatter: this.parseNumber,
                    sortable: true
                },
                {
                    text: 'Area solapada',
                    value: 'overlapped_area',
                    formatter: this.parseNumber,
                    sortable: true
                },
                {
                    text: '% Solapamiento',
                    value: 'overlapped_area_percent',
                    formatter: this.parseNumber,
                    sortable: true
                },
                {
                    text: 'Chacra',
                    value: 'ranch.name',
                    sortable: true
                },
                {
                    text: 'Siembra',
                    value: 'sowing.name',
                    sortable: true
                },
                {
                    text: 'Variable',
                    value: 'variable',
                    sortable: true
                }
            ];
        }
    }

    get enableFindSegments() {
        if (this.dateRangeSelected.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    get existHarvestSelected() {
        return this.filtersHarvestSelected !== null ? true : false;
    }

    updateFiltersCompanySelected(value) {
        this.filtersCompanySelected = value;
    }
    updateFiltersCompanyRV(value) {
        this.filtersCompanyRV = value;
    }
    updateFiltersHarvestSelected(value) {
        this.filtersHarvestSelected = value;
    }
    updateFiltersHarvestRV(value) {
        this.filtersHarvestRV = value;
    }
    updateRangeDate(value) {
        this.dateRangeSelected = value;
    }

    setTodayDate() {
        let todayDate = moment().format('YYYY-MM-DD');
        this.updateRangeDate([todayDate, todayDate]);
    }

    clickFindSegments() {
        if (this.vehicleID !== null) {
            let params = {
                vehicle: this.vehicleID,
                start_date: this.dateRangeSelected[0],
                end_date: this.dateRangeSelected[1],
                ...(this.existHarvestSelected ? { harvest: Number(this.filtersHarvestSelected['id']) } : {})
            };
            this.findSegments(params);
        }
    }

    fixFilter(value) {
        return value;
    }

    customLabelHarvest(farming) {
        return `${farming['company']['name']} - ${farming['name']}`;
    }

    findSegments(parameters) {
        let self = this;
        this.setSegments([]);
        this.loadingTable(true);

        if (!this.isSowing) {
            InsuranceServices.getHarvestVehicleSegments(parameters)
                .then(response => {
                    this.assignSegmentsResponse(response);
                })
                .catch(error => {
                    this.loadingTable(false);
                });
        } else {
            InsuranceServices.getSowingVehicleSegments(parameters)
                .then(response => {
                    this.assignSegmentsResponse(response);
                })
                .catch(error => {
                    this.loadingTable(false);
                });
        }
    }

    assignSegmentsResponse(response) {
        this.loadingTable(false);
        this.setSegments(response['segments']);
    }

    setSegments(newSegments) {
        for (let index = 0; index < newSegments.length; index++) {
            const item = newSegments[index];
            let kei = !this.isSowing ? 'harvest' : 'sowing';
            let company =
                item[kei] && item[kei]['company'] && item[kei]['company']['name'] ? item[kei]['company']['name'] : null;
            if (company == null) {
                company = item[kei]['name'];
            } else {
                company += '_' + item[kei]['name'];
            }

            if (this.isSowing) {
                // overlapped_area / (overlapped_area + sown_area) * 100
                let overlapped_area = item['overlapped_area'];
                let sown_area = item['sown_area'];
                let overlapped_area_plus_sown_area = overlapped_area + sown_area;
                let overlapped_area_percent = 0;
                if (overlapped_area_plus_sown_area > 0) {
                    overlapped_area_percent = (overlapped_area / overlapped_area_plus_sown_area) * 100;
                }
                item['overlapped_area_percent'] = overlapped_area_percent;
            }
        }
        this.items = newSegments;
    }

    loadingTable(value) {
        this.loadingSegments = value;
    }

    viewClickedSegment(clickedSegment) {
        if (!this.isSowing) {
            let parameters = {
                vehicle: this.vehicleID,
                start_date: clickedSegment['start'],
                end_date: clickedSegment['end'],
                ...(clickedSegment && clickedSegment['harvest'] ? { harvest: clickedSegment['harvest']['id'] } : {})
            };
            this.getSegmentInfo(parameters);
        }
    }

    pendingRequestSegment(value) {
        this.pendingSegment = value;
    }

    getSegmentInfo(parameters) {
        //aca
        this.visibilityModalViewSegment(true);
        this.pendingRequestSegment(true);
        this.cancelTokenLoadSegment = Axios.CancelToken.source();
        InsuranceServices.getHarvestVehicleSegment(this.cancelTokenLoadSegment, parameters)
            .then(response => {
                response['vehicle_id'] = this.vehicleID;
                this.segmentInfo = response;
                this.pendingRequestSegment(false);
            })
            .catch(error => {
                this.pendingRequestSegment(false);
                let msg = '';

                if (error && error.response && error.response.data && error.response.data.message) {
                    msg = error.response.data.message;
                } else {
                    msg = 'Ocurrio un error';
                }
                this.segmentInfo = {
                    error: msg
                };
            });
    }

    seeSegmentInMap(item) {
        let vehicleId = this.vehicleID;
        let companyId = this.companyId;
        if (vehicleId !== null && companyId !== -1) {
            openTravelWithParameter(item['start'], item['end'], [vehicleId], companyId);
        }
    }

    closeSegmentModal() {
        this.segmentInfo = null;
        if (this.cancelTokenLoadSegment) {
            this.cancelTokenLoadSegment.cancel();
            this.cancelTokenLoadSegment = null;
        }
        this.visibilityModalViewSegment(false);
    }

    visibilityModalViewSegment(value) {
        this.visibleModalViewSegments = value;
    }
}
